import { Link } from '@tiptap/extension-link';
import { TextAlign } from '@tiptap/extension-text-align';
import { Underline } from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
export const defaultEditorExtensions = [StarterKit.configure({
  bulletList: {
    keepMarks: true,
    keepAttributes: false
  },
  orderedList: {
    keepMarks: true,
    keepAttributes: false
  }
}), Link.configure({
  openOnClick: false // allows clicking on a link for editing without opening it
}), TextAlign.configure({
  types: ['heading', 'paragraph'],
  alignments: ['left', 'right', 'center']
}), Underline.configure({})];